import axios from 'axios'
import okeResponse from 'okeoke.standardresponse'

var User = function (endpoint, userToken = null) {
  this.uuid = null
  this.profile = {}
  this.addresses = []
  this.token = userToken

  const instance = axios.create({
    baseURL: endpoint
  })

  instance.interceptors.request.use(config => {
    config.headers['Accept'] = 'application/json'
    config.headers['Content-Type'] = 'application/json'
    if (this.token != null) {
      config.headers['Authorization'] = 'Bearer ' + this.token
    }
    return config
  })

  this.callbacks = {
    onProfileRefreshed: {},
    onAddressesRefreshed: {}
  }

  this.setToken = (userToken) => {
    this.token = userToken
    this.getProfile()
    this.getAddresses()
  }

  this.addCallback = (cbName, name, func) => {
    try {
      this.callbacks[cbName][name] = func
    } catch (e) {
      console.error('Invalid callback name', cbName)
    }
  }

  this.removeCallback = (cbName, name) => {
    try {
      delete this.callbacks[cbName][name]
    } catch (e) {
      console.error('Invalid callback name', cbName)
    }
  }

  this.callCallbacks = async (cbName, message) => {
    for (let callback of Object.values(this.callbacks[cbName] || {})) {
      if (typeof callback === 'function') {
        try {
          callback(message)
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  const findAddressIndex = (address) => {
    if (address == null || address.id == null) return -1
    let idx = this.addresses.findIndex(item => item.id === address.id)
    return idx
  }

  const updateAddressInArray = (address) => {
    if (address.id == null) return -1
    let idx = findAddressIndex(address)
    if (idx >= 0) {
      this.addresses[idx] = { ...address }
    } else {
      this.addresses.push({ ...address })
    }
    this.callCallbacks('onAddressesRefreshed', { addresses: this.addresses })
  }

  const deleteAddressFromArray = (address) => {
    let idx = findAddressIndex(address)
    if (idx >= 0) { 
      this.addresses.splice(idx, 1)
      this.callCallbacks('onAddressesRefreshed', { addresses: this.addresses })
    }
  }

  this.getProfile = async () => {
    try {
      let response = await instance.get('/api/v1/user/self')
      if (response.data.success) {
        this.profile = response.data.data
        this.callCallbacks('onProfileRefreshed', { profile: response.data.data })
      }
      return response.data
    } catch (error) {
      return okeResponse(false, 500, '', null)
    }
  }

  this.setProfile = async (profileData) => {
    try {
      let result = await instance.post('/api/v1/user',
        {
          ...profileData
        })
      if (result.data.success) {
        this.getProfile() // Refresh profile info if update successful
      }
      return result.data
    } catch (error) {
      console.log(error)
      return { success: false, code: 500, message: '', data: error }
    }
  }

  this.getAddresses = async (addressTypes) => {
    try {
      let data = {
        addressTypes: addressTypes
      }
      let response = await instance.post('/api/v1/user/getAddresses', data);
      if (response.data.success) {
        this.addresses = response.data.data
        this.callCallbacks('onAddressesRefreshed', { addresses: response.data.data })
        // console.log(this.addresses)
      }
      return response.data
    } catch (error) {
      return okeResponse(false, 500, '', null)
    }
  }

  this.getAddress = async (id) => {
    try {
      let data = {
        id: id
      }
      let response = await instance.post('/api/v1/user/getAddress', data)
      return response.data
    } catch (error) {
      return okeResponse(false, 500, '', null)
    }
  }

  this.setAddress = async (address) => {
    try {
      let data = {
        address: address
      }
      let response = await instance.post('/api/v1/user/setAddress', data)
      if (response.data.success) {
        updateAddressInArray({...address, id: response.data.data})
      }
      return response.data
    } catch (error) {
      return okeResponse(false, 500, '', null)
    }
  }

  this.deleteAddress = async (id) => {
    try {
      let data = {
        id: id
      }
      let response = await instance.post('/api/v1/user/deleteAddress', data);
      if (response.data.success) {
        deleteAddressFromArray({ id })
      }
      return response.data
    } catch (error) {
      return okeResponse(false, 500, '', null)
    }
  }
}

export { User }
